import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxCircleToggleModule } from '@aposin/ng-aquila/circle-toggle';
import { DarkModeComponent } from './dark-mode.component';

@NgModule({
  declarations: [DarkModeComponent],
  imports: [
    CommonModule,
    NxButtonModule,
    NxCircleToggleModule
  ],
  exports: [DarkModeComponent]
})
export class DarkModeModule { }
